export const ROUTES_WITHOUT_HEADER = [
  'main',
  'kiosk-options',
  'kiosk-order-options',
  'save-past-orders',
  'number-lookup',
  'past-info',
  'auth-form',
  'payment',
  'confirmation',
];

export const ROUTE_WITH_START_OVER = 'menu';

export default {
  ROUTES_WITHOUT_HEADER,
  ROUTE_WITH_START_OVER,
};



// WEBPACK FOOTER //
// ./src/apps/kiosk/constants.js